export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Person",
  "name": "Rob Lasa",
  "url": "https://souldadrob.com",
  "image": "https://souldadrob.com/og-image-new.jpg",
  "description": "One man's honest record of what happens when you stop performing.",
  "sameAs": [
    "https://www.youtube.com/@souldadrob",
    "https://www.linkedin.com/in/roblasa",
    "https://www.instagram.com/souldadrob/",
    "https://www.facebook.com/souldadrob"
  ],
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "General Inquiry",
    "url": "https://souldadrob.com/connect"
  }
};

export const personSchema = {
  "@context": "https://schema.org",
  "@type": "Person",
  "name": "Rob Lasa",
  "url": "https://souldadrob.com",
  "image": "https://souldadrob.com/rob-portrait.jpg",
  "description": "Rob Lasa is a dad of four boys documenting what happens when you stop performing and start being honest.",
  "knowsAbout": [
    "Nice Guy Syndrome",
    "Men's Mental Health",
    "Self-Honesty",
    "Identity"
  ],
  "sameAs": [
    "https://www.youtube.com/@souldadrob",
    "https://www.linkedin.com/in/roblasa",
    "https://www.instagram.com/souldadrob/",
    "https://www.facebook.com/souldadrob"
  ]
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Rob Lasa",
  "url": "https://souldadrob.com",
  "description": "One man's honest record of what happens when you stop performing.",
  "publisher": organizationSchema,
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://souldadrob.com/blog?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

export const faqSchema = (faqs: Array<{ question: string; answer: string }>) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

export const articleSchema = (article: {
  title: string;
  description: string;
  author: string;
  datePublished: string;
  dateModified?: string;
  image?: string;
  url: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": article.title,
  "description": article.description,
  "author": {
    "@type": "Person",
    "name": article.author
  },
  "publisher": organizationSchema,
  "datePublished": article.datePublished,
  "dateModified": article.dateModified || article.datePublished,
  "image": article.image || "https://souldadrob.com/og-image-new.jpg",
  "url": article.url
});

export const assessmentSchema = {
  "@context": "https://schema.org",
  "@type": "Quiz",
  "name": "Nice Guy Syndrome Assessment",
  "description": "A starting point for honest self-reflection on people-pleasing, emotional suppression, and the nice guy trap.",
  "url": "https://souldadrob.com/nice-guy-assessment",
  "author": personSchema,
  "educationalUse": "Self-Assessment",
  "typicalAgeRange": "30-50",
  "hasPart": {
    "@type": "Question",
    "text": "Discover your nice guy patterns and start being honest about what's really going on"
  }
};

export const videoObjectSchema = (video: {
  name: string;
  description: string;
  thumbnailUrl: string;
  uploadDate: string;
  contentUrl: string;
  embedUrl: string;
  duration?: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "VideoObject",
  "name": video.name,
  "description": video.description,
  "thumbnailUrl": video.thumbnailUrl,
  "uploadDate": video.uploadDate,
  "contentUrl": video.contentUrl,
  "embedUrl": video.embedUrl,
  "duration": video.duration,
  "publisher": organizationSchema
});
